module.exports = __webpack_public_path__ + "static/media/23.4963a76c.jpg";